import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};

function* getMarketingList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-marketing?page=" + actions.page
        : apiUrl + "/opa-marketing" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_MARKETING_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_MARKETING_RESPONSE_GET", value: error });
  }
}

function* getMarketing(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-marketing/${actions.query}?include=products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "MARKETING_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "MARKETING_RESPONSE_GET", value: error });
  }
}

function* resetMarketing() {
  yield put({ type: "MARKETING_RESPONSE_RESET" });
}

function* addMarketing(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-marketing";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "MARKETING_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "MARKETING_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}
function* updateMarketing(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };

    let url = `${apiUrl}/opa-marketing/${actions.marketingUuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "MARKETING_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "MARKETING_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}
function* deleteMarketing(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-marketing/" + actions.marketingUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "MARKETING_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "MARKETING_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }

}

export function* getSagaMarketingList() {
  yield takeEvery("GET_LIST_MARKETING", getMarketingList);
}

export function* getSagaMarketing() {
  yield takeEvery("GET_MARKETING", getMarketing);
}

export function* resetSagaMarketing() {
  yield takeEvery("RESET_MARKETING", resetMarketing);
}

export function* addSagaMarketing() {
  yield takeEvery("ADD_MARKETING", addMarketing);
}

export function* updateSagaMarketing() {
  yield takeEvery("UPDATE_MARKETING", updateMarketing);
}

export function* deleteSagaMarketing() {
  yield takeEvery("DELETE_MARKETING", deleteMarketing);
}

